import styled from "styled-components";

export const InnerContents = styled.div`
  border-radius: 40px 40px 0px 0px;
  background: #eceef6;
  box-sizing: border-box;
  padding: 24px;
  height: calc(100vh - 64px);
  overflow: ${({ overflow = "auto" }) => overflow};
  display: flex;
  flex-direction: ${({ direction = "column" }) => direction};
  flex-grow: 1;
  gap: ${({ gap = "8px" }) => gap};
  overflow: scroll;
`;
